import React from "react";

import { Home } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import MainSolidButton from "../../components/MainSolidButton";
import MainText from "../../components/MainText";

export default function ErrorNotFoundPage() {
  return (
    <Box
      style={{ minHeight: "90vh", width: "100%" }}
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      py={4}
    >
      <Box style={{ width: "90%", maxWidth: "450px" }}>
        <MainText center color="regular" size="body">
          Erro 404
        </MainText>

        <MainText center color="black" size="title">
          Página Não Encontrada
        </MainText>

        <Box my={1}>
          <MainText center color="regular" size="body">
            Se você acha que algo deveria estar aqui, entre em contato conosco através do fomulário
            logo abaixo.
          </MainText>
        </Box>

        <MainText center color="black" size="body">
          {window.location.href}
        </MainText>

        <Box display={"flex"} justifyContent="center" alignItems={"center"} gap={2} mt={4}>
          <MainSolidButton
            fullWidth
            text="Início"
            icon={<Home />}
            onClick={() => window.location.replace("/")}
          />
        </Box>
      </Box>
    </Box>
  );
}
